<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">search</i>
                        </div>
                        <h4 class="card-title ">Filtros</h4>
                    </div>
                    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" novalidate="novalidate" autocomplete="off">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="created_at" class="bmd-label-floating">Data da chegada da Venda no Pós venda <span class="text-danger">*</span></label>
                                        <date-picker
                                            range
                                            v-model="form.created_at"
                                            lang="pt-br"
                                            format="DD/MM/YYYY"
                                            placeholder="Escolha uma data"
                                            :not-after="end_at"
                                        ></date-picker>
                                        <label v-if="validation.created_at != null" id="created_at-error" class="error" for="created_at">{{ validation.created_at }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="branch_id" class="bmd-label-floating">Loja <span class="text-danger">*</span></label>
                                        <model-list-select
                                            class="form-control"
                                            :list="branches"
                                            option-value="id"
                                            option-text="name"
                                            placeholder="Loja"
                                            v-model="form.branch_id"
                                            @input="handlerChangeBranch"
                                        >
                                        </model-list-select>
                                        <label v-if="validation.branch_id != null" id="branch_id-error" class="error" for="branch_id">{{ validation.branch_id }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="team_id" class="bmd-label-floating">Equipe</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="teams"
                                            placeholder="Todas"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.team_id"
                                            @input="handlerChangeTeams">
                                        </model-list-select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="representative" class="bmd-label-floating">Representante</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="representatives"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.representative">
                                        </model-list-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-md-4">
                                    <div
                                        class="form-group bmd-form-group is-filled"
                                        >
                                        <label form="status" class="bmd-label-floating">Status</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="after_sale_status"
                                            option-value="id"
                                            option-text="status"
                                            v-model="form.status"
                                        ></model-list-select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div
                                        class="form-group bmd-form-group is-filled"
                                        >
                                        <label for="situation" class="bmd-label-floating">Situação</label>
                                        <model-list-select 
                                            class="form-control"
                                            :list="situations"     
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.situation">
                                        </model-list-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                            <button type="submit" class="btn btn-fill btn-rose">Gerar</button>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import jwtService from '../../../services/jwt.service';

    export default {
        computed: {
            after_sale_status() {
                var afterStatus = [
                    {
                        id: null,
                        status: "Todos"
                    }
                ];
                return afterStatus.concat(this.$store.state.after_sale_status.itens);
            },
            branches() {
                return this.$store.state.defaults.branches;
            },
            teams: {
                get() {
                    return this.$store.state.teams.itens;
                }
            }
        },
        created() {
            var self = this;

            self.getDataAfterSaleStatus();
        },
        data() {
            return {
                end_at: Vue.moment(),
                form: {
                    branch_id: this.$store.state.auth.user.branch_id,
                    created_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    representative: {id: null, name: "Todos"},
                    status: {id: null, name: "Todos"},
                    situation: "A",
                    team_id: null
                },
                representatives: [
                    {
                        id: null,
                        name: "Todos"
                    }
                ],
                situations: [
                    {
                        id: "A",
                        name: "Alocada"
                    },
                    {
                        id: "C",
                        name: "Cancelada"
                    },
                    {
                        id: "N",
                        name: "Não alocada"
                    },
                    {
                        id: "T",
                        name: "Todas"
                    }
                ],
                validation: {
                    branch_id: null,
                    created_at: null
                }
            }
        },
        methods: {
            async getDataAfterSaleStatus() {
              var self = this;

              self.$root.$emit('onLoading');
              const response = self.$store.dispatch('after_sale_status/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                    self.getDataTeams(self.form.branch_id);
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                    self.getDataTeams(self.form.branch_id);
                });
            },
            async getSalesmans() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('users/getSalesmans', {all_users:true});

                response.then(() => {
                    self.$root.$emit('onLoading');
                });

                response.catch(() => {
                    self.$root.$emit('onLoading');
                });
            },
            async getDataTeams(branch_id) {
                var self = this;

                self.$root.$emit('onLoading');

                const response =  self.$store.dispatch('teams/all', branch_id);

                response.then(function () {
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            async getTeam(_id) {
                var self = this;

                self.$root.$emit('onLoading');

                const response =  self.$store.dispatch('teams/get', _id);

                response.then(function (_team) {
                    self.representatives = [
                        {
                            id: null,
                            name: "Todos"
                        }
                    ];
                    _team.salesmans.forEach((salesman) => {
                        self.representatives.push(salesman);
                    });
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            handlerChangeBranch(branch_id) {
                setTimeout(() => {
                    this.form.branch_id = branch_id;
                    this.form.team_id = null;
                    this.form.representative = null;
                    this.getDataTeams(branch_id);
                }, 800)
            },
            handlerChangeTeams(team_id) {
                this.getTeam(team_id);
            },
            onReset() {
                this.form = {
                    branch_id: null,
                    created_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    representative: {id: null, name: "Todos"},
                    status: {id: "A", name: "Alocada"},
                };
            },
            onSubmit() {
                var self = this;
                var valid = true;

                self.validation = {
                    branch_id: null,
                    created_at: null
                };

                if (self.form.branch_id == null) {
                    self.validation.branch_id = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.created_at[0] == null || self.form.created_at[1] == null) {
                    self.validation.created_at = 'Campo obrigatório!';
                    valid = false;
                }

                if (valid) {
                    var dataToSend = {
                        branch_id: self.form.branch_id,
                        created_at: self.form.created_at,
                        team_id: self.form.team_id,
                        situation: self.form.situation,
                        representative_id: self.form.representative ? self.form.representative.id : null,
                        status_id: self.form.status ? self.form.status.id : null
                    }
                    var serialize = JSON.stringify(dataToSend);
                    window.open("print-after-sales?form=" + serialize, '_blank');
                }
            }
        }
    };
</script>
